import styled from "styled-components";

export const StyledReportButton = styled.div`
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  color: var(--opsColor);
  color: rgb(73, 73, 73);

  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  outline: none;
  display: flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  box-sizing: border-box;
  justify-content: center;
  padding: 0px 17px;
  border-radius: 100px;
  position: absolute;
  right: 10px;
  top: 1px;
  z-index: 1000;
  height: 46px;
  box-sizing: border-box;
  pointer-events: all;

  span {
    pointer-events: none;
    font-size: 14px;
    font-weight: 400;
    text-transform: lowercase;
    line-height: normal;
    letter-spacing: normal;
  }

  svg {
    pointer-events: none;
    /* stroke: var(--opsColor); */
  }
`;
